module.exports = __webpack_public_path__ + "static/media/copy_icon.9424f8b4.svg";